import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_bilhandel-nett/artifacts/f2maoqds_DigiCar-logo-yellow.svg" 
              alt="DigiCar" 
              className="h-8 mb-4"
            />
            <p className="text-sm leading-relaxed">
              DigiCar gjør bilsalg enkelt. Over 2000 bilforhandlere konkurrerer om å gi deg best mulig pris.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Sider</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/selg-bilen" className="hover:text-white transition-colors">Selg bilen</Link></li>
              <li><Link to="/bedrift" className="hover:text-white transition-colors">Bedrift</Link></li>
              <li><Link to="/forhandler" className="hover:text-white transition-colors">Forhandler</Link></li>
              <li><Link to="/ofte-stilte-sporsmal" className="hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Kontakt</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="tel:47494900" className="hover:text-white transition-colors">47 49 49 00</a></li>
              <li><a href="mailto:post@digicar.no" className="hover:text-white transition-colors">post@digicar.no</a></li>
              <li className="pt-2 text-xs">Man-Fre: 08:00-16:00</li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Juridisk</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/personvern" className="hover:text-white transition-colors">Personvern</Link></li>
              <li><Link to="/vilkar" className="hover:text-white transition-colors">Vilkår</Link></li>
              <li><Link to="/cookies" className="hover:text-white transition-colors">Cookies</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-sm text-center">
          <p>&copy; 2025 DigiCar AS. Alle rettigheter reservert.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;